import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function renameGroup(id, name) {
	return fetch(
		`${ENDPOINT_URL}/admingroup/renamegroup`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify({
				id,
				name,
			}),
		})
	)
		.then((response) => {
			if (response.status === 409) alert('Gruppen eksisterer allerede');
			else if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
